import { BANKS } from '../../../../constants';

// Ð Ð°ÐºÑÑÑÑ ÑÐ¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ¾Ð². ÐÑÐ½ÐµÑÐµÐ½Ñ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ°, ÑÑÐ¾Ð±Ñ Ð¿Ð¾ÐºÑÑÑÑ ÑÐµÑÑÐ°Ð¼Ð¸
// Ð±ÐµÐ· React Ð¸ http-ÐºÐ»Ð¸ÐµÐ½ÑÐ°: ÑÐ¾ÑÑÐ°Ð² ÑÐ°ÐºÑÑÑÐ¾Ð² ÑÐµÑÐ°ÐµÑ Ð´Ð²Ðµ Ð²ÐµÑÐ¸ ÑÑÐ°Ð·Ñ â Ð»Ð¸ÑÐ½Ð¸Ð¹
// Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐ¹ Ð·Ð°Ð¿Ð¸ÑÐ°ÐµÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð² Ð±Ð»Ð¾ÐºÐµ, Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÑÐ¸Ð¹ ÑÐ²Ð¾Ð´Ð¸Ñ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð¾ÑÐºÐ°Ð·.
//
// Ð¡Ð¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ðµ ÑÐ¸Ð¿Ð°Ð¼ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² (completed_order_documents_types):
// 46 Â«Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾Â» (serialNumberId 1..4 Ð¸ 5..10), 47 Â«Ð¤Ð¾ÑÐ¾ VINÂ», 45 Â«Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÂ»,
// 48 Â«Ð¤Ð¾ÑÐ¾ Ð¾Ð´Ð¾Ð¼ÐµÑÑÐ°Â».

// banks â ÐºÐ°ÐºÐ¸Ð¼ Ð±Ð°Ð½ÐºÐ°Ð¼ Ð½ÑÐ¶ÐµÐ½ ÑÐ½Ð¸Ð¼Ð¾Ðº. Freedom Ð¿ÑÐ¾ÑÐ¸Ñ Ð¿ÑÑÑ ÑÐ°ÐºÑÑÑÐ¾Ð² Ð¸ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ,
// Jet Finance â ÑÐµ Ð¶Ðµ Ð¿Ð»ÑÑ Ð¾Ð´Ð¾Ð¼ÐµÑÑ, Ð²ÑÐ¾ÑÐ¾Ð¹ VIN Ð¸ Ð¿Ð¾Ð´ÐºÐ°Ð¿Ð¾ÑÐ½Ð¾Ðµ Ñ ÑÐ°Ð»Ð¾Ð½Ð¾Ð¼.
// required Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ Ðº Freedom: Ð±ÐµÐ· ÑÑÐ¸Ñ Ð¿ÑÑÐ¸ Ð¾Ð½ Ð¾ÑÐºÐ»Ð¾Ð½Ð¸Ñ Ð·Ð°ÑÐ²ÐºÑ.
// newCar â Ð¼Ð°ÑÐ¸Ð½Ð° Ð¸Ð· ÑÐ°Ð»Ð¾Ð½Ð°: Ð·Ð°Ð»Ð¾Ð³ Ð¾ÑÐµÐ½Ð¸Ð²Ð°ÑÑ Ð½ÐµÑÐµÐ³Ð¾, Jet Finance Ð¶Ð´ÑÑ ÑÐ¾Ð»ÑÐºÐ¾
// ÑÐ½Ð¸Ð¼Ð¾Ðº VIN, Ð¸ Freedom Ð¿Ð¾ Ð½Ð¾Ð²Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ ÑÐ¾ÑÐ¾ Ð½Ðµ Ð¿ÑÐ¾ÑÐ¸Ñ Ð²Ð¾Ð²ÑÐµ.
const FREEDOM = BANKS.FREEDOM;
const JETFIN = BANKS.JETFIN;
const BOTH = [FREEDOM, JETFIN];

// Â«Ð¤Ð¾ÑÐ¾ VINÂ» Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ ÑÐ¸Ð¿Ð¾Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²: ÑÐµÑÐ¸Ñ 1 â Ð²ÑÐ±Ð¸ÑÑÐ¹, ÑÐµÑÐ¸Ñ 2 â Ð½Ð°ÐºÐ»ÐµÐ¹ÐºÐ°.
const VIN_TYPE_ID = 47;

export const SLOTS = [
  { key: 'FRONT_SIDE_IMAGE', label: 'Ð¡Ð¿ÐµÑÐµÐ´Ð¸', typeId: 46, serial: 1, required: true, banks: BOTH },
  { key: 'LEFT_SIDE_IMAGE', label: 'Ð¡Ð»ÐµÐ²Ð°', typeId: 46, serial: 2, required: true, banks: BOTH },
  { key: 'RIGHT_SIDE_IMAGE', label: 'Ð¡Ð¿ÑÐ°Ð²Ð°', typeId: 46, serial: 3, required: true, banks: BOTH },
  { key: 'BACK_SIDE_IMAGE', label: 'Ð¡Ð·Ð°Ð´Ð¸', typeId: 46, serial: 4, required: true, banks: BOTH },
  {
    key: 'VIN_IMAGE',
    label: 'Ð¤Ð¾ÑÐ¾ VIN',
    hint: 'Ð²ÑÐ±Ð¸ÑÑÐ¹ Ð½Ð° ÐºÑÐ·Ð¾Ð²Ðµ',
    typeId: 47,
    serial: 1,
    required: true,
    banks: BOTH,
  },
  {
    key: 'TECHNICAL_PASSPORT_FRONT_SIDE_IMAGE',
    label: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ (Ð»Ð¸ÑÐµÐ²Ð°Ñ)',
    typeId: 45,
    serial: 1,
    required: false,
    banks: BOTH,
  },
  { key: 'ODOMETER_IMAGE', label: 'ÐÑÐ¾Ð±ÐµÐ³', typeId: 48, serial: 1, required: false, banks: [JETFIN] },
  {
    key: 'VIN2_IMAGE',
    label: 'ÐÑÐ¾ÑÐ¾Ð¹ VIN',
    hint: 'Ð½Ð°ÐºÐ»ÐµÐ¹ÐºÐ°',
    typeId: 47,
    serial: 2,
    required: false,
    banks: [JETFIN],
  },
  { key: 'ENGINE_IMAGE', label: 'ÐÐ²Ð¸Ð³Ð°ÑÐµÐ»Ñ', typeId: 46, serial: 5, required: false, banks: [JETFIN] },
  { key: 'INTERIOR_IMAGE', label: 'Ð¡Ð°Ð»Ð¾Ð½', typeId: 46, serial: 6, required: false, banks: [JETFIN] },
  { key: 'PANEL_IMAGE', label: 'ÐÐ°Ð½ÐµÐ»Ñ Ð¿ÑÐ¸Ð±Ð¾ÑÐ¾Ð²', typeId: 46, serial: 7, required: false, banks: [JETFIN] },
  { key: 'SEATS_IMAGE', label: 'Ð¡Ð¸Ð´ÐµÐ½ÑÑ', typeId: 46, serial: 8, required: false, banks: [JETFIN] },
  { key: 'TRANSMISSION_IMAGE', label: 'ÐÐ¾ÑÐ¾Ð±ÐºÐ°', typeId: 46, serial: 9, required: false, banks: [JETFIN] },
  { key: 'TRUNK_IMAGE', label: 'ÐÐ°Ð³Ð°Ð¶Ð½Ð¸Ðº', typeId: 46, serial: 10, required: false, banks: [JETFIN] },
];

// ÐÐ°ÐºÐ¸Ðµ ÑÐ°ÐºÑÑÑÑ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ. ÐÑÐ½ÐµÑÐµÐ½Ð¾ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ°, ÑÑÐ¾Ð±Ñ Ð¿Ð¾ÐºÑÑÑÑ
// ÑÐµÑÑÐ°Ð¼Ð¸: Ð»Ð¸ÑÐ½Ð¸Ð¹ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐ¹ ÑÐ°ÐºÑÑÑ Ð±Ð»Ð¾ÐºÐ¸ÑÑÐµÑ Ð²ÑÐ±Ð¾Ñ Ð±Ð°Ð½ÐºÐ°, Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÑÐ¸Ð¹ â
// ÑÐ²Ð¾Ð´Ð¸Ñ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð¾ÑÐºÐ°Ð·.
export const slotsFor = (banks = [], { newCar = false } = {}) => {
  // ÐÐ¾Ð²Ð°Ñ Ð¼Ð°ÑÐ¸Ð½Ð°: Ð¾ÑÐµÐ½Ð¸Ð²Ð°ÑÑ Ð·Ð°Ð»Ð¾Ð³ Ð½ÐµÑÐµÐ³Ð¾, Ð±Ð°Ð½Ðº Ð¶Ð´ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ VIN â Ð½Ð¾ Ð¾Ð±Ð°, Ð¸
  // Ð²ÑÐ±Ð¸ÑÑÐ¹ Ð½Ð° ÐºÑÐ·Ð¾Ð²Ðµ, Ð¸ Ð½Ð°ÐºÐ»ÐµÐ¹ÐºÑ (Albina Ð¸Ð· Jet Finance, 08.10.2026). ÐÑÐ¾ÑÐ¾Ð¹
  // ÑÐ½Ð¸Ð¼Ð¾Ðº Ñ Ð±/Ñ Ð°Ð²ÑÐ¾ Ð½ÐµÐ¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐ¹, Ð·Ð´ÐµÑÑ Ð±ÐµÐ· Ð½ÐµÐ³Ð¾ Ð·Ð°ÑÐ²ÐºÐ° Ð½Ðµ Ð¿Ð¾ÐµÐ´ÐµÑ.
  if (newCar) {
    if (!banks.includes(JETFIN)) return [];

    return SLOTS.filter((slot) => slot.typeId === VIN_TYPE_ID).map((slot) => ({
      ...slot,
      required: true,
    }));
  }

  // Ð/Ñ Ð¸ ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½ÑÐµ: ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµ ÑÐ°ÐºÑÑÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½ÑÐ¶Ð½Ñ Ð±Ð°Ð½ÐºÐ°Ð¼ ÑÑÐ¾Ð¹ ÑÐ´ÐµÐ»ÐºÐ¸ â
  // Ð² ÑÐ´ÐµÐ»ÐºÐµ Ð±ÐµÐ· Jet Finance Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÐµÐ·Ð°ÑÐµÐ¼ ÑÐ½Ð¸Ð¼Ð°ÑÑ Ð±Ð°Ð³Ð°Ð¶Ð½Ð¸Ðº Ð¸ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¿ÑÐ¸Ð±Ð¾ÑÐ¾Ð².
  return SLOTS.filter((slot) => slot.banks.some((bank) => banks.includes(bank)));
};
